import { render, staticRenderFns } from "./extraHourSec.vue?vue&type=template&id=f23c39c6&scoped=true&"
import script from "./extraHourSec.vue?vue&type=script&lang=js&"
export * from "./extraHourSec.vue?vue&type=script&lang=js&"
import style0 from "./extraHourSec.vue?vue&type=style&index=0&id=f23c39c6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f23c39c6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
